import { render } from "./PublicationBroadcast.vue?vue&type=template&id=50e86424&scoped=true"
import script from "./PublicationBroadcast.vue?vue&type=script&lang=js"
export * from "./PublicationBroadcast.vue?vue&type=script&lang=js"

import "./PublicationBroadcast.vue?vue&type=style&index=0&id=50e86424&lang=stylus&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50e86424"]])

export default __exports__